import type Konva from "konva";
import { dispatchMetadataEvent } from "../../lib/metadata-history/dispatch";
import { snapMetadataNode } from "./metadata-snapping";
import { layoutLocalPoint } from "../../lib/schedule-art/layout-coordinates";

export function moveMetadataElement(path: string, point: number[]) {
  dispatchMetadataEvent({ type: "position/set", path, point });
}

export function attachCanvasDrag(node: Konva.Group, origin: number[], onMove: (point: number[]) => void) {
  node.draggable(true);
  node.on("mouseenter.canvasDrag", () => { node.getStage()!.container().style.cursor = "grab"; });
  node.on("mouseleave.canvasDrag", () => { node.getStage()!.container().style.cursor = ""; });
  node.on("dragstart.canvasDrag", () => { node.getStage()!.container().style.cursor = "grabbing"; });
  node.on("dragend.canvasDrag", () => {
    const stage = node.getStage();
    if (!stage) return;
    stage.container().style.cursor = "";
    const rotation = node.getAttr("metadataLayoutRotation") as number | undefined;
    const point = layoutLocalPoint([node.x(), node.y()], origin, rotation);
    onMove(point);
  });
}

export function attachMetadataDrag(
  node: Konva.Group,
  path: string,
  origin: number[],
  onMove: typeof moveMetadataElement,
  onDragMove = (event: Konva.KonvaEventObject<MouseEvent>) => snapMetadataNode(node, origin, event.evt.altKey),
) {
  attachCanvasDrag(node, origin, point => onMove(path, point.map(Math.round)));
  node.on("dragmove.canvasDrag", onDragMove);
}
